import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import { injectIntl, intlShape } from 'react-intl';
import { lightBlack } from 'styles/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import messages from './messages';

const Toggle = styled(Button)`
  &.btn {
    color: ${lightBlack};
    margin: auto;
  }
`;

function ElevationControl(props) {
  const { onChange, intl } = props;
  const label = intl.formatMessage(messages.elevationButton);

  return (
    <Toggle onClick={onChange} aria-label="Toggle control panel">
      <FontAwesomeIcon icon="mountain" size="sm" className="mr-2" />
      {label}
    </Toggle>
  );
}

ElevationControl.propTypes = {
  onChange: PropTypes.func.isRequired,
  intl: intlShape,
};

export default injectIntl(ElevationControl);
